<template>
<div>

<v-layout d-flex>
<v-card>
<v-toolbar height="52" flat>
<v-icon large color="#4A76A8" left>mdi-account-circle</v-icon>
<v-toolbar-title >
{{accounts.accGroups.selectedGr.title_ru}} ({{accounts.accGroups.list.length}})
</v-toolbar-title>

<v-spacer></v-spacer>
 
<v-btn v-if="!accounts.accGroups.list.length"   @click="delAllProxy()" color="red" small style="text-transform:none;color:white">Очистить прокси</v-btn>

<v-tooltip v-if="selecta>0" top  max-width="250">
  <span>Кликните, что бы переместить выбранные аккаунты в другую группу</span>
  <v-btn slot="activator" icon  color="#273C51"  @click="accounts.modals.changeGr = true" flat > <v-icon>mdi-arrow-bottom-left</v-icon></v-btn>
 </v-tooltip>

<v-tooltip v-if="accounts.accGroups.list.length>0 && !accounts.modals.checking" top  max-width="250">
  <span>Кликните, что бы проверить валидность всех аккаунтов</span>
  <v-btn slot="activator" icon  color="green"  @click="checkAll()" flat > <v-icon>mdi-account-check</v-icon></v-btn>
 </v-tooltip>

 <v-tooltip v-else top  max-width="250">
   <span>Пожалуйста дождитесь, когда чекер завершит работу</span>
   <v-btn slot="activator" icon  color="grey"  flat > <v-icon>mdi-alarm-check</v-icon></v-btn>
  </v-tooltip>

<v-tooltip v-if="selecta>0" top  max-width="250">
  <span>Модифицировать выбранные аккаунты</span>
  <v-btn slot="activator" icon  color="#273C51"  @click="modify()" flat > <v-icon>mdi-pencil</v-icon></v-btn>
</v-tooltip>


<v-tooltip v-if="selecta>0" top  max-width="250">
  <span>Отменить выбранные</span>
  <v-btn slot="activator" icon  color="#273C51"  @click="unSelectAll()" flat > <v-icon>mdi-tab-unselected</v-icon></v-btn>
</v-tooltip>

<v-tooltip v-if="accounts.accGroups.list.length>0" top  max-width="250">
  <span>Выбрать все аккаунты</span>
  <v-btn slot="activator" icon  color="#273C51"  @click="selectAll()" flat > <v-icon>mdi-select</v-icon></v-btn>
</v-tooltip>

<v-tooltip v-if="accounts.accGroups.list.length>0" top  max-width="250">
  <span>Кликните, что бы просмотреть пароли</span>
  <v-btn slot="activator" icon  color="#273C51"  @click="meneger()" flat > <v-icon>mdi-lock</v-icon></v-btn>
 </v-tooltip>

<v-tooltip v-if="!accounts.adding.leftList.length"  top  max-width="250">
   <span>Кликните, что бы добавить новые аккаунты</span>
   <v-btn slot="activator" icon  color="#273C51"  @click="add()" flat > <v-icon>mdi-plus</v-icon></v-btn>
</v-tooltip>
<v-tooltip v-else  top  max-width="250">
   <span>Что бы добавить новые аккаунты, дождитесь или отмените текущие добавление</span>
   <v-btn disabled slot="activator" icon  color="#4A76A8"  flat > <v-icon>mdi-plus</v-icon></v-btn>
</v-tooltip>

<v-tooltip v-if="accounts.accGroups.list.length>0"  top max-width="250">
  <span>Кликните, что бы удалить аккаунты</span>
  <v-btn slot="activator" icon  color="red"  @click="accounts.modals.deleteAccounts = true" flat > <v-icon>mdi-delete</v-icon></v-btn>
 </v-tooltip>

 <v-tooltip v-else top max-width="250">
   <span>Нет аккаунтов для удаления</span>
   <v-btn slot="activator" icon  color="grey"  @click="" flat > <v-icon>mdi-delete</v-icon></v-btn>
  </v-tooltip>

</v-toolbar>

<v-card-text>
<!-- Добавление аккаунтов -->
<div v-if="!accounts.adding.hideBar"  class="text-xs-center" style="marginTop:25pxp;marginBottom:25px" >
<v-card>
  <v-toolbar flat small>
    <v-toolbar-title>
    <span v-if="addingPercent< 100" style="color:#273C51">Выполняется добавление аккаунтов {{addingPercent}}%</span>
    <span v-else style="color:#273C51">Добавление аккаунтов завершено</span>
  </v-toolbar-title>
  <v-spacer></v-spacer>
  <v-btn v-if="accounts.adding.leftList.length>0" @click="stopAddingProc()" flat small>
    <v-icon small>mdi-backup-restore</v-icon>
    <span  style="color:#273C51;font-size:.8em">Отменить</span>
  </v-btn>
  <v-btn v-else @click="newAddingProc()" flat small>
    <v-icon small>mdi-plus</v-icon>
    <span  style="color:#273C51;font-size:.8em">Добавить еще</span>
  </v-btn>
  <v-btn @click="hideAddingBar()" flat small><v-icon small>mdi-close</v-icon>
    <span  style="color:#273C51;font-size:.8em">Скрыть</span>
  </v-btn>
  </v-toolbar>
  <v-card-text>
<v-btn @click="lookAtAddingList('leftList')" flat small>
  <span style="color:blue">Осталось: {{accounts.adding.leftList.length}}</span>
</v-btn>
<v-btn @click="lookAtAddingList('successList')" flat small>
  <span style="color:green">Успешная авторизация: {{accounts.adding.successList.length}}</span>
</v-btn>
<v-btn @click="lookAtAddingList('invalidList')"  flat small>
  <span style="color:red">Невалидные: {{accounts.adding.invalidList.length}}</span>
</v-btn>
  </v-card-text>
</v-card>
</div>

<v-dialog  scrollable width="600" v-model="accounts.modals.addingSelectedList">
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title><span style="color:#273C51">{{accounts.adding.selectedListTitle}} <span v-if="accounts.adding.selectedListName">({{accounts.adding[accounts.adding.selectedListName].length}})</span></span></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon color="red" @click="accounts.modals.addingSelectedList = false">mdi-close</v-icon>
    </v-toolbar>
    <v-card-text>
      <v-textarea rows="15" solo readonly v-model="addingSelectedList">

      </v-textarea>
    </v-card-text>
    <v-card-actions>
<v-spacer></v-spacer>
<v-btn  v-if="!addingSelectedList.length" disabled color="#273C51"  small flat><v-icon left>mdi-content-copy</v-icon> Копировать</v-btn>
<v-btn   v-else color="#273C51" @click="copyAddingSelectedList()" small flat><v-icon left>mdi-content-copy</v-icon> Копировать</v-btn>
<v-btn color="red" @click="accounts.modals.addingSelectedList = false" small flat>Закрыть</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
<!-- Добавление аккаунтов  закрываем-->


<div  v-if="accounts.accGroups.list.length < 1 && !accounts.loader" class="text-xs-center" style="marginTop:50px;marginBottom:50px">
<span style="color:#B8B8B8;font-size:1.4em">
Для работы необходимо добавить хотя бы 1 валидный аккаунт
</span>
</div>



<div v-if="accounts.loader" class="text-xs-center" style="marginTop:50px" >
<v-progress-circular :size="70" :width="7" color="#4A76A8" indeterminate ></v-progress-circular>
</div>


<!--Вывод аккаунтов -->
<div v-if="accounts.accGroups.list.length>0"  v-for="(item, index) in accounts.accGroups.list" style="margin:5px" >
<v-badge      style="width:100%" color="grey" overlap>


<v-tooltip  top slot="badge" >
<v-icon slot="activator"  color="white" class="white--text"  @click.stop="deleteAccount(item)">mdi-close</v-icon>
<span>Удалить</span>
</v-tooltip>

<v-toolbar    :dark='item.selected'   @click="selector(item)"    flat>
<img style="border-radius:50%" :src="item.photo_50">
<v-toolbar-title @click.stop=""  >
<a style="color:#4A76A8;text-decoration:none" target="_blank" v-bind ='{href: "http://vk.com/id"+item.id}' >{{item.title}}</a>
<div style="color:gray;font-size:.7em">
<span style="margin-right:5px">{{item.info.date|dateFormatFull}}</span>
  <v-tooltip  top v-if="item.is_closed">
  <span>Закрытый аккаунт</span>
  <v-icon style="margin-left:3px"   slot="activator"  small color="yellow">mdi-account-alert</v-icon>
  </v-tooltip>
  <v-tooltip  top v-if="item.info.my_post">
  <span>На данном аккаунте был опубликован пост</span>
  <v-icon style="margin-left:3px" slot="activator"  small color="gray">mdi-comment-multiple-outline</v-icon>
  </v-tooltip>
  <v-tooltip  top v-if="item.info.my_repost">
  <span>На данном аккаунте был опубликован репост</span>
  <v-icon style="margin-left:3px" slot="activator"  small color="gray">mdi-share</v-icon>
  </v-tooltip>
</div>
</v-toolbar-title>

<v-spacer></v-spacer>


<v-btn style="margin:3px"   icon v-if="JSON.parse(item.info.limits).groupUpdates.expire > Date.now()/1000">
<v-icon medium color="yellow">mdi-flash</v-icon>
</v-btn>

<v-tooltip top left min-width="250" max-width="250">
<div>
<div>Друзей всего: {{item.info.friends_count}}</div>
<div>Заявок отправлено: {{item.info.friends_req_count}}</div>
<div v-if="JSON.parse(item.info.limits).friendRequest.expire" style="color:yellow"><v-icon small color="yellow">mdi-alert</v-icon> Достигнут лимит на новые заявки</div>
</div>
<template slot="activator">
<v-btn style="margin:3px"   icon v-if="item.info.valid == '1' && item.info.task_able == '1'" >
<v-icon medium
v-if="JSON.parse(item.info.limits).friendRequest.expire"
color="yellow">mdi-account-multiple-plus
</v-icon>
<v-icon v-else medium  color="green">mdi-account-multiple-plus</v-icon>
</v-btn>
<v-btn style="margin:3px"   icon v-else>
<v-icon medium color="red">mdi-account-multiple-plus</v-icon>
</v-btn>
</template>
</v-tooltip>



<v-btn style="margin:3px"    icon v-if="item.info.valid == '1' && item.info.task_able == '1'" >
<v-badge  overlap >
<template v-if="JSON.parse(item.info.limits).messageSend.counter>0" v-slot:badge>
<span style="font-size:.9em">{{JSON.parse(item.info.limits).messageSend.counter}}</span>
</template>
<v-tooltip v-if="JSON.parse(item.info.limits).messageSend.expire" top max-width="250">
<v-icon medium slot = "activator" @click.stop="msg(item)"color="yellow">mdi-email-lock</v-icon>
<div>
Лимит на отправку сообщений, начиная с {{new Date(JSON.parse(item.info.limits).messageSend.expire*1000).toLocaleString().slice(0,-3)}}
</div>
</v-tooltip>
<v-icon medium v-else @click.stop="msg(item)" color="green">mdi-email </v-icon>
</v-badge>
</v-btn>
<v-btn v-else style="margin:3px"   icon>
<v-badge overlap color="#FF8F18">
<template style="background-color:black" v-if="JSON.parse(item.info.limits).messageSend.counter>0" v-slot:badge><span style="font-size:.9em">{{JSON.parse(item.info.limits).messageSend.counter}}</span></template>
<v-icon medium @click.stop="msg(item)" color="red">mdi-email </v-icon>
</v-badge>
</v-btn>


<v-btn style="margin-left:9px"   icon @click.stop="info(item)"  >
<v-icon medium color="brown" >mdi-information</v-icon>
</v-btn>

<v-btn style="margin:3px"   icon @click.stop="check(item)"  >
<v-icon medium  v-if="item.info.valid == '1'" color="green" > mdi-account-check </v-icon>
<v-icon medium  v-if="item.info.valid == '0'" color="red" > mdi-account-check </v-icon>
</v-btn>


</v-toolbar>
</v-badge>

</div>
<!--закрываем вывод аккаунтов -->

</v-card-text>
</v-card>
</v-layout>




<info v-if="accounts.modals.info" :accounts="accounts" ></info>
<addAcc v-if="accounts.modals.addAccounts" :accounts="accounts" :modals="accounts.modals"></addAcc>
<mody v-if="accounts.modals.modifier" :accounts="accounts" :selecta="selecta"></mody>
<manager v-if="accounts.modals.meneger" :accounts="accounts"></manager>
<deleteAcc v-if="accounts.modals.deleteAccount"  :accounts="accounts"></deleteAcc>
<v-dialog persistent scrollable v-model="accounts.modals.deleteAccounts" width="550">
<deleteAccounts v-if="accounts.modals.deleteAccounts" :accounts="accounts"></deleteAccounts>
</v-dialog>





<v-dialog scrollable v-model="accounts.modals.grList" width="450">

<v-card  >
  <v-toolbar flat height="42" color="#4A76A8">
    <v-toolbar-title style="color:white">Выберите группу</v-toolbar-title>
    <v-spacer/>
    <v-btn @click="accounts.modals.grList = false" icon><v-icon color="white">mdi-close</v-icon></v-btn>
  </v-toolbar>
  <v-card-text>
     <div v-for="item in accounts.accGroups.grList">
       <p style="cursor:pointer;color:#4A76A8" @click="changeGroup(item)">{{item.title_ru}}</p>
     </div>
  </v-card-text>
</v-card>
</v-dialog>


<v-dialog persistent scrollable v-model="accounts.modals.changeGr" width="450">

<v-card  >
  <v-toolbar flat height="42" color="#273C51">
    <v-toolbar-title style="color:white">Переместить в другой список</v-toolbar-title>
    <v-spacer/>
    <v-btn @click="accounts.modals.changeGr = false" icon><v-icon color="white">mdi-close</v-icon></v-btn>
  </v-toolbar>
  <v-card-text>
     <div v-for="item in accounts.accGroups.grList">
       <p v-if="item.gr_id>0 && accounts.accGroups.selectedGr.gr_id != item.gr_id" style="cursor:pointer;color:#4A76A8" @click="ChangeGr(item)">{{item.title_ru}}</p>
     </div>
  </v-card-text>
</v-card>
</v-dialog>



<v-dialog v-if="accounts.modals.msg"  v-model="accounts.modals.msg"  width="1200"    scrollable  >
<msg  :accounts="accounts"> </msg>
</v-dialog>

</div>
</template>




<script>
import axios from 'axios'
import deleteAcc from './deleteAcc.vue'
import deleteAccounts from './deleteAccounts.vue'
import manager from './manager.vue'
import mody from './mody.vue'
import info from './info.vue'
import addAcc from './addAcc.vue'
import msg from './msg.vue'
export default {
components:{info,addAcc,mody,manager,deleteAcc,msg,deleteAccounts},
 data: function(){
  return {

accounts:{
loader: false,
sender: {},

adding:{
    selectedListTitle: '',
    selectedListName: '',
    hideBar: true,
    addingProc: false,
    leftList: [],
    successList: [],
    invalidList: [],
},

accGroups: {
grList: [],
selectedGr: {
gr_id: 0,
gr_title: 'общий список',
title_ru:"общий",
gr_info: '',
},
list: [],
selected: [],
selectedLimits: {},
deleteId: {},
},
  modals :{
    msg: false,
    modifier:false,
    info: false,
    addAccounts:false,
    deleteAccount: false,
    deleteAccounts:false,
    checkAccount: false,
    meneger: false,
    grList: false,
    addingSelectedList: false,
    checking:false,
    changeGr:false
  },

},

}
},



created(){

     //this.accounts.accGroups.selectedGr.gr_id = item.gr_id
     //this.accounts.accGroups.selectedGr.gr_title = item.title_ru
     //this.accounts.accGroups.selectedGr.gr_info = item.gr_info

     //this.updateAccounts()
     //this.accounts.modals.grList = false

 //this.$store.state.ui.profilesGroups[this.$store.state.ui.profilesGrSelected] = this.$route.meta.grId
 console.log(this.$route)
 //alert(this.$route.meta.grId)
 this.getGrList()
 this.updateAccounts()

},

computed:{
addingSelectedList(){
  if(this.accounts.adding.leftList){
  switch (this.accounts.adding.selectedListName) {
    case 'leftList':
    return this.accounts.adding.leftList.join('\n')
      break;
    case 'successList':
    return this.accounts.adding.successList.join('\n')
      break;
    case 'invalidList':
    return this.accounts.adding.invalidList.join('\n')
      break;
    default:
      return ''
      break;
  }
}
},
addingPercent(){
  let percent = (this.accounts.adding.invalidList.length + this.accounts.adding.leftList.length + this.accounts.adding.successList.length) / 100
  return Math.ceil( (this.accounts.adding.invalidList.length + this.accounts.adding.successList.length) /percent)
},
selecta (){
   let aki = this.accounts.accGroups.list.filter((item,i,arr)=>{
     return item.selected
   })
   return aki.length
},



  },




methods:{

ChangeGr(grId){
let aki = this.accounts.accGroups.list.filter((item,i,arr)=>{
    return item.selected
  })
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/change_gr_id.php', {
method: 'POST',
data: {
grId:grId,
accounts: aki
}
}).then(response => {
this.accounts.modals.changeGr = false
this.$router.go()
})
},

checkAll(){
this.accounts.modals.checking = true
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/check_all.php', {
method: 'POST',
data: {
accounts: this.accounts.accGroups.list
}
}).then(response => {
this.accounts.modals.checking = false
alert('Чекер аккаунтов завершил работу')
this.updateAccounts()
})

},





delAllProxy(){
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/accounts_del_all_proxy.php', {
     method: 'POST',
     }).then(response => {
 alert('Очистили прокси на всех аккаунтах')
     })
},






  msg(item){
    this.accounts.sender = []
    this.accounts.sender = item
    this.accounts.modals.msg = true
  },


deleteSelected(){

},


  copyAddingSelectedList(){
    navigator.clipboard.writeText(this.accounts.adding[this.accounts.adding.selectedListName].join('\n'))
    .then ( ()=>{
     alert('Скопорованно '+this.accounts.adding[this.accounts.adding.selectedListName].length)
   })
  },


lookAtAddingList(listName){
  this.accounts.adding.selectedListName = listName
switch (listName) {
  case 'leftList':
  this.accounts.adding.selectedListTitle = 'Список еще недобавленных'
    break;
  case 'successList':
  this.accounts.adding.selectedListTitle = 'Список авторизованных'
    break;
  case 'invalidList':
  this.accounts.adding.selectedListTitle = 'Список невалидных'
    break;
  default:
    break;
}
this.accounts.modals.addingSelectedList = true
},

hideAddingBar(){
this.accounts.adding.hideBar = true
},
newAddingProc(){
  this.accounts.modals.addAccounts = true
},
stopAddingProc(){
this.accounts.adding.addingProc = false

this.accounts.adding.leftList = []
this.accounts.adding.successList = []
this.accounts.adding.invalidList = []
this.accounts.adding.selectedListTitle = ''
this.accounts.adding.selectedListName = ''
},

getGrList(){
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/gr_list_get.php', {
     contentType: 'JSONP',
     method: 'get',
     }).then(response => {
       this.accounts.accGroups.grList = response.data
       this.accounts.accGroups.selectedGr = response.data[this.$route.meta.grId]
     })
},



modify(){
  this.accounts.modals.modifier = true
},


selector(item){
   if(!item.selected){
     item.selected = true
   } else {
          item.selected = false
   }
},

selectAll(){
  this.accounts.accGroups.list.forEach(item=>{
    item.selected = true
  })
},
unSelectAll(){
  this.accounts.accGroups.list.forEach(item=>{
    item.selected = false
  })
},

  updateAccounts(){
    //this.$route.meta.grId
  if(this.accounts.accGroups.list.length < 1)  {this.accounts.loader = true}
    axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/accounts_get.php', {
       contentType: 'JSONP',
       method: 'get',
       params: {
         grId: this.$route.meta.grId,//this.accounts.accGroups.selectedGr.gr_id,
       }
       }).then(response => {
   this.accounts.loader = false
   if(response.data ){
     this.accounts.accGroups.list = response.data
   } else {
     this.accounts.accGroups.list = []
   }
   this.accounts.loader = false
       })

  },


deleteAccount: function(item){
   this.accounts.modals.deleteAccount = true
    this.accounts.accGroups.deleteId = item
},

check (account){
  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/check.php', {
       method: 'POST',
       data: {
         id: account.id
       }
     }).then(response => {
   this.updateAccounts()
     })

},


info(item){
this.accounts.modals.info = true
this.accounts.accGroups.selected = item
this.accounts.accGroups.selectedLimits = JSON.parse(this.accounts.accGroups.selected.info.limits)
},

  add: function(){
    this.accounts.modals.addAccounts =  true
  },
  meneger: function(){
    this.accounts.modals.meneger =  true
  },


},
filters: {
  dateFormatFull(item){
    var months = ['Янв.','Фев.','Мар.','Апр.','Мая','Июнь.','Июль.','Авг.','Сен.','Окт.','Ноя.','Дек.'];

    let d =  new Date(item * 1000)
    let mins
    if(d.getMinutes()> 9){
      mins = d.getMinutes()
    } else {
      mins = "0"+ d.getMinutes()
    }
    return  d.getDate()+" "+months[d.getMonth()]+"  "+ d.getHours() +":" + mins

  }
},
}
</script>

<style>
 .row-selected {
   background-color: red
 }
</style>
